export default {
  savedMessage: 'Saved',
  player: {
    submitted: 'This assessment has been already submitted',
    pageTitle: '{{name}} | Great Minds Digital',
    labelBundle: {
      saveButtonLabel: 'Save',
      item: 'Question',
      collapseMenu: 'Collapse Menu',
      saved: 'has been saved',
      test: 'assessment',
      saveTestSuccessfully: 'This assessment has been saved. Do you want to resume or exit the assessment?',
      isAllResponsesAttempted: 'All parts have been attempted. Do you want to submit it now?',
      submitWithUnattemptedQuestion: 'part is unattempted.',
      submitWithUnattemptedQuestions: 'parts are unattempted.'
    }
  }
};